import React, { PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';

const NoSsr: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export default dynamic(() => Promise.resolve(NoSsr), { ssr: false });
